import { Box, Typography } from "@mui/material";

export const BoxWithBorder = ({ title, children, subTitle }) => {
  return (
    <Box
      sx={{
        border: "1px solid #EEEEEE",
        background: "#fff",
        display: "flex",
        alignItems: "start",
        padding: "1.5rem 2.5rem",
        borderRadius: "1rem",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flex: 1,
          flexDirection: "column",
        }}
      >
        <Box
          display={"flex"}
          gap={title ? "18px" : "0"}
          flexDirection={"column"}
        >
          {title ? (
            <Typography fontSize={"20px"} fontWeight={600}>
              {title}{" "}
              {subTitle ? (
                <span
                  style={{
                    fontWeight: 400,
                    color: "#9D9D9D",
                    fontSize: "16px",
                  }}
                >
                  ({subTitle})
                </span>
              ) : (
                ""
              )}
            </Typography>
          ) : (
            <></>
          )}
          <Box>{children}</Box>
        </Box>
      </Box>
    </Box>
  );
};
